
/**
 * Custom hook that returns true only if the user is on a production host
 * Supports: https://agp.e-reliable.com/ and automotor.e-reliable.com
 * @returns {boolean} - true if the current host is a production host, false otherwise
 */
const useIsProductionHost = (): boolean => {

  const currentHost = window.location.host;

  const productionHosts = [
    'agp.e-reliable.com',
    'automotor.e-reliable.com',
    'aol.e-reliable.com',
    // 'automotor.localhost:3000',
    // 'automotor.recette.cloud.e-reliable.pro'
  ];

  return productionHosts.some(host => currentHost.includes(host));


};

export default useIsProductionHost; 